import { getTranslatedText, useIntl } from '@nile/components';
import { Button, ButtonGroup, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { planDescriptionKeyMap } from '@nile/banyan/src/Utils/pricingHelper';
import styled from 'styled-components';

const Wrapper = styled.div`
  .name {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #ff1462;
  }
  .excerpt {
    font-family: Poppins, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    color: #4d4d4d;
  }
  .line {
    width: 88px;
    height: 2px;
    border-top: 2px solid #f05;
    margin: 10px 0;
  }
`;

function PlanNameInfoCard(props) {
  const { plan, tenure, setTenure, hideDescription, subscription } = props;
  const intl = useIntl();
  return (
    <Wrapper className="fx">
      <div className="f11">
        <p className="name">{plan?.planName}</p>
        {planDescriptionKeyMap.hasOwnProperty(plan?.chargeBeePlanId) && (
          <p className="excerpt">
            <TextStyle>
              {getTranslatedText(
                intl,
                planDescriptionKeyMap[plan?.chargeBeePlanId || 'DEFAULT']
              )}
            </TextStyle>
          </p>
        )}
        {!hideDescription && (
          <p className="desc italic">
            <TextStyle>
              Price for
              <span className="mlr5">
                <TextStyle weight="Bold">{plan?.planName}</TextStyle>
              </span>
              subscription on
              <span className="mlr5">
                <TextStyle weight="Bold">
                  {tenure === 'MONTHLY' ? 'monthly' : 'annual'}
                </TextStyle>
              </span>
            </TextStyle>
          </p>
        )}
        <div className="line" />
      </div>
      <div className="flex jend btn-switcher mt-20 mb-20">
        <ButtonGroup segmented>
          <Button
            outline={tenure === 'MONTHLY'}
            onClick={() => setTenure('MONTHLY')}
            disabled={subscription?.currentPlanPrice?.duration === 'YEARLY'}
          >
            <FormattedMessage id="admin.billing.upgradeplan.tenure.monthly" />
          </Button>
          <Button
            outline={tenure === 'YEARLY'}
            onClick={() => setTenure('YEARLY')}
          >
            <FormattedMessage id="admin.billing.upgradeplan.tenure.yearly" />
          </Button>
        </ButtonGroup>
      </div>
    </Wrapper>
  );
}

export default PlanNameInfoCard;
